import { render, staticRenderFns } from "./gsr_ktxh_report.vue?vue&type=template&id=275bb7fd&scoped=true"
import script from "./gsr_ktxh_report.vue?vue&type=script&lang=js"
export * from "./gsr_ktxh_report.vue?vue&type=script&lang=js"
import style0 from "./gsr_ktxh_report.vue?vue&type=style&index=0&id=275bb7fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275bb7fd",
  null
  
)

export default component.exports